import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'
import { ApplicationRoles } from '../utils'

// External users only — internal (TxDMV) staff accounts are managed via SSO, not
// self-service, so their primary email can't be changed from this page.
export const EditPrimaryEmailFeature = {
  Roles: [...ApplicationRoles, MccsRoles.BROKER],

  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(EditPrimaryEmailFeature.Roles, user),
} satisfies Feature
